import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ConfigTargetingAppState } from "./config_request";
export const protobufPackage = "snapchat.cdp.cof";
export interface BoltSignals {
    boltUseCase: number;
    boltCdnExperimentationId: number;
    boltIsContentPopular: boolean;
    boltClientAppState: ConfigTargetingAppState;
}
function createBaseBoltSignals(): BoltSignals {
    return { boltUseCase: 0, boltCdnExperimentationId: 0, boltIsContentPopular: false, boltClientAppState: 0 };
}
export const BoltSignals: MessageFns<BoltSignals> = {
    encode(message: BoltSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.boltUseCase !== 0) {
            writer.uint32(8).uint32(message.boltUseCase);
        }
        if (message.boltCdnExperimentationId !== 0) {
            writer.uint32(16).uint32(message.boltCdnExperimentationId);
        }
        if (message.boltIsContentPopular !== false) {
            writer.uint32(24).bool(message.boltIsContentPopular);
        }
        if (message.boltClientAppState !== 0) {
            writer.uint32(32).int32(message.boltClientAppState);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): BoltSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBoltSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.boltUseCase = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.boltCdnExperimentationId = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.boltIsContentPopular = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.boltClientAppState = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<BoltSignals>, I>>(base?: I): BoltSignals {
        return BoltSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<BoltSignals>, I>>(object: I): BoltSignals {
        const message = createBaseBoltSignals();
        message.boltUseCase = object.boltUseCase ?? 0;
        message.boltCdnExperimentationId = object.boltCdnExperimentationId ?? 0;
        message.boltIsContentPopular = object.boltIsContentPopular ?? false;
        message.boltClientAppState = object.boltClientAppState ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
